import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { set, capitalize, get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { convertSelectLabel, currencySymbols, SelectBoxStyles, methodShipment, checkIsNumber } from '../../../../../Components/helper';
import { errorpath, productInfoFieldPath } from '../../../ProductCosting/fieldPath';
import AlertPopup from '../../../../../Components/ModalPopup/AlertPopup';
import * as action from '../../../ProductCosting/store/ProductCosting.action';
import useValidationHooks from '../../../ProductCosting/Hooks/useValidationHooks';
import useShowHideSectionHooks from '../Hooks/useShowHideSectionHooks';

export function ProductInfoTable({ productInfoObj }) {
  const { productCostingstate, setProductCostingState, globalError, index } = productInfoObj;
  const {
    currencyOptionsArr,
    incotermsOptionsArr,
    productInfo: { supplierId, currency, incoterms, reference, shipmentMethod, targetCost },
  } = productCostingstate;

  const { t } = useTranslation('common');
  const { onChangeCheckIfErrorExist } = useValidationHooks();
  const dispatch = useDispatch();
  const {
    MultiProductSelectReducer: { suppliers },
  } = useSelector((reduxState) => reduxState);

  const { onLoadDisable, isDisabled } = useShowHideSectionHooks(productInfoObj);

  const [comState, setState] = useState({
    showSupplierChangePopup: false,
    supplierSelected: null,
    showCurrencyChangepopup: false,
    selectedCurrency: null,
  });

  const handleDropDown = async (value, path, dependentPath) => {
    const copyState = productCostingstate;
    if (path.includes('supplierId')) {
      if (supplierId && supplierId?._id !== value?._id) {
        set(copyState, path, value);
        setProductCostingState((state) => ({ ...state }));
      } else {
        set(copyState, path, value);
      }
    } else if (path.includes('currency')) {
      setState((prevState) => ({
        ...prevState,
        showCurrencyChangepopup: true,
        selectedCurrency: value,
      }));
      set(copyState, productInfoFieldPath().SELECTED_CURRENCY, value);
    } else set(copyState, path, value);
    if (dependentPath) {
      set(copyState, dependentPath, currencySymbols[value]);
    }
    if (path.includes('supplierId')) {
      set(copyState, productInfoFieldPath().SELECTED_CURRENCY, value?.companies?.currency);
    }
    setProductCostingState((state) => ({ ...state, ...copyState }));
  };

  const handleChange = async (value, path) => {
    const copyState = productCostingstate;
    set(copyState, path, value);
    setProductCostingState((state) => ({ ...state, ...copyState }));
  };

  const updateError = (path) => {
    onChangeCheckIfErrorExist(path, globalError);
  };

  const onChangeSupplier = (selected) => {
    handleDropDown(selected, productInfoFieldPath().SELECTED_SUPPLIER);
  };

  const updateCurrency = async () => {
    const copyState = productCostingstate;

    const obj = {
      supplierId: supplierId?._id,
      currency: comState?.selectedCurrency,
    };
    const res = await dispatch(action.updateCurrencyinSupplierOverview(obj));
    if (res) {
      setState((prevState) => ({
        ...prevState,
        showCurrencyChangepopup: false,
        supplierSelected: null,
      }));
      set(copyState, productInfoFieldPath().SELECTED_CURRENCY, comState?.selectedCurrency);
      setProductCostingState((state) => ({ ...state, ...copyState }));
    } else {
      setState((prevState) => ({
        ...prevState,
        showCurrencyChangepopup: false,
        supplierSelected: null,
      }));
    }
  };

  useEffect(() => {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    if (get(globalError, 'productInfo.supplierId', '')) {
      updateError(errorpath().PRODUCTINFO.ERROR_SUPPLIER);
    }
    // eslint-disable-next-line sonarjs/no-duplicate-string
    if (get(globalError, 'productInfo.currency', '')) {
      updateError(errorpath().PRODUCTINFO.ERROR_CURRENCY);
    }
    // eslint-disable-next-line sonarjs/no-duplicate-string
    if (get(globalError, 'productInfo.targetCost', '')) {
      updateError(errorpath().PRODUCTINFO.ERROR_TARGETCOST);
    }
    // eslint-disable-next-line sonarjs/no-duplicate-string
    if (get(globalError, 'productInfo.incoterms', '')) {
      updateError(errorpath().PRODUCTINFO.ERROR_INCOTERMS);
    }
    if (get(globalError, 'productTemplate', '')) {
      updateError(errorpath().SELECT_TEMPLATE);
    }
  }, []);
  return (
    <>
      <div className="table-responsive average-colourway-table">
        <table className="table common-class-bottom common-custom-table product-costing-tbl">
          <thead>
            <tr>
              <th className="w-250px">{t('COSTING.REFERENCE')}</th>
              <th className="w-250px">{t('COSTING.SUPPLIER')}</th>
              <th className="w-200px">{t('COSTING.CURRENCY')}</th>
              <th className="w-250px"> {t('COSTING.TARGET_COST')}</th>
              <th className="w-200px">{t('COSTING.INCOTERMS')}</th>
              <th className="w-250px">{t('COSTING.SHIPMENT_METHOD')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div style={{ marginBottom: '12px' }} className="common-input-control">
                  <input
                    type="text"
                    value={reference}
                    onChange={(e) => {
                      handleChange(e.target.value, productInfoFieldPath().REFERENCE);
                    }}
                    placeholder={t('FILTER.COSTING_REFRENCE')}
                    className="form-control border-top-0 border-left-0 border-right-0"
                  />
                </div>
              </td>

              <td className="position-zindex">
                <div className="common-react-select mb-0 mt-0">
                  <Select
                    options={suppliers}
                    onChange={(selected) => {
                      onChangeSupplier(selected);
                      if (get(globalError, 'productInfo.supplierId', '')) {
                        updateError(errorpath().PRODUCTINFO.ERROR_SUPPLIER);
                      }
                    }}
                    getOptionLabel={(option) => capitalize(option.name)}
                    getOptionValue={(option) => option.name}
                    value={supplierId}
                    isDisabled={isDisabled}
                    styles={SelectBoxStyles}
                    placeholder={t('COSTING_TO_DO_LIST.SELECT_SUPLIERS')}
                    menuPosition="fixed"
                    menuShouldBlockScroll
                    menuShouldScrollIntoView
                    className="common-select"
                    classNamePrefix="common-select"
                  />
                </div>
                {!supplierId && <span className="error-message">{get(globalError, 'productInfo.supplierId', '')}</span>}
                {supplierId && <span className="error-message" />}
              </td>
              <td>
                {currency || (
                  <div className="common-react-select mb-0 mt-0">
                    <Select
                      options={currencyOptionsArr}
                      value={convertSelectLabel(currency, true)}
                      styles={SelectBoxStyles}
                      onChange={(selected) => {
                        handleDropDown(selected.value, productInfoFieldPath().SELECTED_CURRENCY);
                        if (get(globalError, 'productInfo.currency', '')) {
                          updateError(errorpath().PRODUCTINFO.ERROR_CURRENCY);
                        }
                      }}
                      isDisabled={isDisabled || onLoadDisable}
                      placeholder={t('COSTING_TO_DO_LIST.SELECT_CURENCY')}
                      menuPosition="fixed"
                      menuShouldBlockScroll
                      menuShouldScrollIntoView
                      className="common-select"
                      classNamePrefix="common-select"
                    />
                    <span className="error-message">{get(globalError, 'productInfo.currency', '')}</span>
                  </div>
                )}
              </td>
              <td>
                <div className="common-input-control mb-0 mt-0">
                  <input
                    id={`${index}target`}
                    type="text"
                    value={targetCost}
                    className="form-control border-top-0 border-left-0 border-right-0"
                    placeholder={t('FILTER.ENTER_TARGET_COST')}
                    onChange={(e) => {
                      if (checkIsNumber(e.target.value)) {
                        handleChange(e.target.value, productInfoFieldPath().TARGET_COST);
                        if (get(globalError, 'productInfo.targetCost', '')) {
                          updateError(errorpath().PRODUCTINFO.ERROR_TARGETCOST);
                        }
                      }
                    }}
                  />
                </div>
                {!targetCost && <span className="error-message">{get(globalError, 'productInfo.targetCost', '')}</span>}
                {targetCost && <span className="error-message" />}
              </td>
              <td>
                <div className="common-react-select mb-0 mt-0">
                  <Select
                    options={incotermsOptionsArr}
                    value={convertSelectLabel(incoterms, true)}
                    styles={SelectBoxStyles}
                    onChange={(selected) => {
                      handleDropDown(selected.value, productInfoFieldPath().SELECTED_INCOTERMS);
                      if (get(globalError, 'productInfo.incoterms', '')) {
                        updateError(errorpath().PRODUCTINFO.ERROR_INCOTERMS);
                      }
                    }}
                    isDisabled={isDisabled || onLoadDisable}
                    placeholder={t('COSTING_TO_DO_LIST.SELECT_INTO')}
                    menuPosition="fixed"
                    menuShouldBlockScroll
                    menuShouldScrollIntoView
                    className="common-select"
                    classNamePrefix="common-select"
                  />
                </div>
                {isEmpty(incoterms) && <span className="error-message">{get(globalError, 'productInfo.incoterms', '')}</span>}
                {!isEmpty(incoterms) && <span className="error-message" />}
              </td>
              <td>
                <div className="common-react-select mb-0 mt-0">
                  <Select
                    options={methodShipment}
                    value={convertSelectLabel(shipmentMethod, true)}
                    styles={SelectBoxStyles}
                    onChange={(selected) => {
                      handleDropDown(selected.value, productInfoFieldPath().SELECTED_SHIPMENT_METHOD);
                    }}
                    isDisabled={isDisabled || onLoadDisable}
                    placeholder={t('PROGRESS_INDICATOR.SELECT_SHIPMENT_METHOD')}
                    menuPosition="fixed"
                    menuShouldBlockScroll
                    menuShouldScrollIntoView
                    className="common-select"
                    classNamePrefix="common-select"
                  />
                  <span className="error-message" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {comState.showCurrencyChangepopup && (
        <AlertPopup
          onOpen={comState.showCurrencyChangepopup}
          onConfirm={() => {
            updateCurrency();
          }}
          title={t('ALERT_POPUP_VIEW.PRODUCT_COSTING.CURRENCY.TITLE')}
          message={t('ALERT_POPUP_VIEW.PRODUCT_COSTING.CURRENCY.MESSAGE')}
          description={t('ALERT_POPUP_VIEW.PRODUCT_COSTING.CURRENCY.DESCRIPTION')}
          toggle={() =>
            setState((prevState) => ({
              ...prevState,
              showCurrencyChangepopup: !prevState.showCurrencyChangepopup,
              selectedCurrency: null,
            }))
          }
        />
      )}
    </>
  );
}

export default ProductInfoTable;
